export default class CouponReferer {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        refererCouponRetrieve(id: ${id}) {
          id
          totalPerUser
          active          
          coupon {
            id
            title
            deal {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    response.data.data.refererCouponRetrieve.compressed = {
      coupon: response.data.data.refererCouponRetrieve.coupon   
    };  
    response.data.data.refererCouponRetrieve.deal = response.data.data.refererCouponRetrieve.coupon.deal.id;  
    response.data.data.refererCouponRetrieve.coupon = response.data.data.refererCouponRetrieve.coupon.id;

    return response.data.data.refererCouponRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query {
        refererCouponList {
          results {
            id
            coupon {
              id
              title
            }
            totalPerUser
            active
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.refererCouponList.results.reverse();
  }

  static async filter(axios, active) {
    const response = await axios.post(
      '/graphql/',
      `query{
        refererCouponList(active: ${active}) {
          results {
            id
            coupon {
              id
              title
            }
            totalPerUser
            active
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.refererCouponList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/', {
        query: `mutation deleteRefererCoupon($id: ID!) {
          deleteRefererCoupon(id: $id){
            ok
          }
        }`,
        variables: {
          "id": id
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.deleteRefererCoupon.ok;
  }

}